export default __webpack_public_path__ + "static/blob5-0c17bf5e4f1a9f205c4768203f1645f0.svg";